import React, { useEffect, useState, useMemo } from "react";
import { getAllBallkidComments } from "../firebaseService";
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useGroup } from "../context/GroupContext";

const BallkidCommentsPage = () => {
  const { activeGroup } = useGroup();
  const memberSingular = activeGroup?.memberSingular || "Mitglied";
  const [ballkids, setBallkids] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchBallkidsWithComments = async () => {
      try {
        const data = await getAllBallkidComments();
        setBallkids(data);
      } catch (error) {
        console.error("Fehler beim Abrufen der Ballkinder-Daten:", error);
      }
    };

    fetchBallkidsWithComments();
  }, []);

  const filteredBallkids = useMemo(() => {
    const sorted = [...ballkids].sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    if (!search.trim()) return sorted;
    const q = search.toLowerCase();
    return sorted.filter((bk) => (bk.name || "").toLowerCase().includes(q));
  }, [ballkids, search]);

  const handlePrint = () => {
    window.print();
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ textAlign: "center", mb: 2 }}>
        Kommentare
      </Typography>
      <Box sx={{ display: "flex", gap: 2, mb: 2, alignItems: "center", flexWrap: "wrap" }}>
        <TextField
          placeholder={`${memberSingular} suchen...`}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          size="small"
          sx={{ minWidth: 250 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        <Button variant="contained" onClick={handlePrint}>
          Drucken
        </Button>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Name</strong></TableCell>
              <TableCell><strong>Kommentare</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredBallkids.map((ballkid) => (
              <TableRow key={ballkid.id}>
                <TableCell>{ballkid.name || "Unbekannt"}</TableCell>
                <TableCell>
                  {ballkid.comments?.length > 0
                    ? ballkid.comments.map((comment, index) => (
                        <div key={index} style={{ marginBottom: "8px" }}>
                          <strong>{new Date(comment.timestamp).toLocaleDateString()}:</strong>
                          <br />
                          {comment.text}
                          <br />
                          <em>- {comment.userEmail || "Unbekannt"}</em>
                        </div>
                      ))
                    : "Keine Kommentare"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default BallkidCommentsPage;
